/**
 * Calculate optimal image size to fit viewport
 * @param {number} naturalWidth - Natural image width
 * @param {number} naturalHeight - Natural image height
 * @param {number} maxWidthPercent - Max width as % of viewport (default: 0.9)
 * @param {number} maxHeightPercent - Max height as % of viewport (default: 0.8)
 * @returns {{width: number, height: number}} - Calculated dimensions
 */
export const calculateImageSize = (naturalWidth, naturalHeight, maxWidthPercent = 0.9, maxHeightPercent = 0.8) => {
  if (!naturalWidth || !naturalHeight) {
    return null;
  }

  // Allow image to take up to maxWidthPercent of window width and maxHeightPercent of window height
  const maxW = Math.max(100, window.innerWidth * maxWidthPercent);
  const maxH = Math.max(100, window.innerHeight * maxHeightPercent);

  const scale = Math.min(1, maxW / naturalWidth, maxH / naturalHeight);
  const width = Math.round(naturalWidth * scale);
  const height = Math.round(naturalHeight * scale);

  return { width, height };
};

/**
 * Load image and get its dimensions
 * @param {string} imageUrl - Image URL to load
 * @returns {Promise<{width: number, height: number}>} - Image dimensions
 */
export const getImageDimensions = (imageUrl) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight
      });
    };
    img.onerror = reject;
    img.src = imageUrl;
  });
};


